import { Result } from 'antd'
import { Link } from 'react-router-dom'

import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'

export default function ErrorPage() {
  return (
    <Result
      status="error"
      title="Oops! Something went wrong."
      subTitle="Please refresh the page or try again later."
      extra={
        <PDSFlexBox justifyContent="center">
          <Link to="/">
            <PDSButton text="Back Home" />
          </Link>
        </PDSFlexBox>
      }
    />
  )
}
